import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import type { CurrencyCodeType } from '@mint-lib/currencies-helpers';
import { useCurrencyFormatter } from '@mint-lib/formatting-hooks';

import type { SuggestionGridType } from '../../../../types/suggestion.js';

const CurrencyCell = (props: ICellRendererParams<SuggestionGridType>) => {
  const { format: currencyFormatter } = useCurrencyFormatter();

  if (!props.data?.currency) {
    return null;
  }

  return (
    currencyFormatter?.(Number(props.value), {
      currency: (props.data?.currency ?? 'USD') as CurrencyCodeType,
      maxDecimals: 2,
    })?.formatted ?? ''
  );
};

export { CurrencyCell };
